/**
Ref: https://medium.com/front-end-weekly/html5-form-validation-in-react-65712f778196
     https://time2hack.com/form-with-react-html5-validations/
     https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5/Constraint_validation

Note: default props inputRef, onChange, error HelperText can be overridden by passing it in props
*/

import { FormControl, FormLabel } from '@chakra-ui/form-control';
import { Switch } from '@chakra-ui/switch';
import React from 'react';

const FormSwitchField = (props) => {
  const { name, label, id, defaultValue, formGroupProps, switchProps, ...rest } = props;
  return (
    <FormControl display="flex" alignItems="center" {...formGroupProps}>
      <Switch id={id} size="md" isChecked={defaultValue} name={name} {...rest} {...switchProps} />
      <FormLabel htmlFor={id} ml={3} my={0}>
        {label}
      </FormLabel>
    </FormControl>
  );
};

export default FormSwitchField;
